import { render, staticRenderFns } from "./OrderDetailExposureSetting.vue?vue&type=template&id=47459c28&scoped=true&"
import script from "./OrderDetailExposureSetting.vue?vue&type=script&lang=ts&"
export * from "./OrderDetailExposureSetting.vue?vue&type=script&lang=ts&"
import style0 from "./OrderDetailExposureSetting.vue?vue&type=style&index=0&id=47459c28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47459c28",
  null
  
)

export default component.exports